import React from 'react'

const HelloWorld = (props) => {
  const { name } = props

  return (
    <div className="hello-world" style={{
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, sans-serif',
      maxWidth: '800px',
      margin: '50px auto',
      padding: '30px',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      color: 'white',
      borderRadius: '10px',
      boxShadow: '0 10px 30px rgba(0,0,0,0.3)'
    }}>
      <h1 style={{ fontSize: '3em', margin: '0 0 20px 0' }}>Hello, {name}!</h1>
      <p style={{ fontSize: '1.2em', marginBottom: '20px' }}>Welcome to the USOKIE Platform</p>
      <div className="info" style={{
        background: 'rgba(255,255,255,0.1)',
        padding: '20px',
        borderRadius: '8px',
        marginTop: '20px'
      }}>
        <h2 style={{ fontSize: '1.5em', marginTop: '30px' }}>System Information</h2>
        <ul style={{ listStyle: 'none', padding: 0 }}>
          <li style={{ padding: '8px 0', fontSize: '1.1em' }}>
            <strong style={{ color: '#ffd700' }}>Framework:</strong> React on Rails
          </li>
          <li style={{ padding: '8px 0', fontSize: '1.1em' }}>
            <strong style={{ color: '#ffd700' }}>Backend:</strong> Ruby {props.rubyVersion} / Rails {props.railsVersion}
          </li>
          <li style={{ padding: '8px 0', fontSize: '1.1em' }}>
            <strong style={{ color: '#ffd700' }}>Database:</strong> PostgreSQL 17 + Neo4j 5.x
          </li>
          <li style={{ padding: '8px 0', fontSize: '1.1em' }}>
            <strong style={{ color: '#ffd700' }}>Agent Framework:</strong> RubyLLM
          </li>
        </ul>
      </div>
    </div>
  )
}

export default HelloWorld
